import { Injectable, WritableSignal, inject } from '@angular/core';
import { WorkflowSection } from '../../models/workflow/workflow-section.model';
import { WorkflowService } from '../../services/workflow.service';

@Injectable({
  providedIn: 'root',
})
export class ProgressTrackerService {

  private _workflowService: WorkflowService = inject(WorkflowService);

  getWorkflowSections(): WritableSignal<WorkflowSection[]> {
    return this._workflowService.getWorkflowSections();
  }
  showProgressTracker(): WritableSignal<boolean> {
    return this._workflowService.showProgressTracker$;
  }
}
